import { MaintenanceTypeTaskAttributes, Task } from '@/types'
import { MaintenanceTypeTasksMutation } from '../maintenance_type_task/__generated__/create_mutation'
import { Mutation as CreateMutation } from '../maintenance_type_task/create_mutation'
import { useForm } from '@/helpers/useForm'
import { Query as TableQuery } from '@/components/maintenance_type_task/table_query'

interface Props {
  id: string
}
export const Form = ({ id }: Props) => {
  const {
    save,
    saveSuccess,
    formBuilder,
    mutationLoading,
  } = useForm<MaintenanceTypeTasksMutation, MaintenanceTypeTaskAttributes, never, never>({
    defaultValues: {
      name: '',
      taskType: Task.Test,
      required: false,
      maintenanceTypeId: id,
    },
    mutation: CreateMutation,
    resultKey: 'createMaintenanceTypeTask',
    refetchQueries: [TableQuery]
  })

  return (
    <>
      <div>
        { formBuilder.buildQueryError() }
        <div className="grid grid-cols-12 gap-4">
          <span className="col-span-5">{ formBuilder.buildField({ name: 'Name', field: 'name', type: 'text' }) }</span>
          <span className="col-span-5">{ formBuilder.buildField({ name: 'Task type', field: 'taskType', type: 'maintenance-task-type' }) }</span>
          <span className="col-span-2">{ formBuilder.buildField({ name: 'Required', field: 'required', type: 'switch' }) }</span>
        </div>
        <div className="pt-6">
          { formBuilder.saveButton(save, mutationLoading, saveSuccess, 'Add') }
        </div>
      </div>
    </>
  )
}
